import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import TopNav from "./TopNav";
import BottomNav from "./BottomNav";
import Slider from "react-slick";

import { connect } from "react-redux";

const Styles = {
  heroImage: {
    // backgroundImage: "url(/images/CRUISE-1.jpg)",
    height: "500px",
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  heroFilter: {
    height: "500px",
    width: "100%",
    background: "rgba(0,0,0,.5)",
    position: "absolute"
  },
  btmnav: {
    display: "none"
  },
  slider_image: {

  }
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  searchItineraries = (isRange, sdate, edate) => {
    
    if (isRange) {
      if (
        this.props.data.data.settings.departurePortCode &&
        this.props.data.data.settings.arrivalPortCode &&
        sdate &&
        edate
      ) {
        this.setState({
          redirect: true,
          startDate: sdate,
          endDate: edate
        });
      }
    } else {
      if (
        this.props.data.data.settings.departurePortCode &&
        this.props.data.data.settings.arrivalPortCode &&
        sdate
      ) {
        this.setState({
          redirect: true,
          startDate: sdate,
          endDate: edate
        });
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      redirect: false
    });
  }

  componentDidMount() {
    const language = localStorage.getItem("language");
    if (language) {
      this.props.data.data.setLanguage(language);
    } else {
      this.props.data.data.setLanguage("el");
    }
  }

  render() {

    var settings = {
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 15000,
      speed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    if (this.state.redirect) {
      if (this.props.data.data.settings.isRoundTrip) {
        return (
          <Redirect
            to={{
              pathname: `/${this.props.data.data.settings.departurePortCode}/${
                this.props.data.data.settings.arrivalPortCode
              }/${this.state.startDate}/${this.state.endDate}/itineraries`
            }}
          />
        );
      } else {
        return (
          <Redirect
            to={{
              pathname: `/${this.props.data.data.settings.departurePortCode}/${
                this.props.data.data.settings.arrivalPortCode
              }/${this.state.startDate}/${this.state.startDate}/itineraries`
            }}
          />
        );
      }
    }

    return (
      <div>
        <Slider {...settings}>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide4.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide6.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={ {background: 'url("/images/slide8.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide9.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide1.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide2.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide3.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide5.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
          <div>
            <div className="slider_image" style={  {background: 'url("/images/slide7.jpg")', width: "100vw", height: "500px", backgroundPosition: "center", backgroundSize: "cover"} }></div>
          </div>
        </Slider>
        <div>

          <div
            style={this.props.fullpage ? Styles.heroImage : Styles.heroImage}
          >
          
            <div
              style={
                this.props.fullpage ? Styles.heroFilter : Styles.heroFilter
              }
            />
            <TopNav
              data={this.props.data}
              fullpage={this.props.fullpage}
              callbackSearch={this.searchItineraries}
            />
          </div>
          <BottomNav data={this.props.data} />
        </div>
      </div>
    );
  }
}

Header = connect()(Header);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js